import type { Sequence } from "../types/Sequence"

export function* Map<T, N>(
  func: (item: T) => N,
  ...arrays: Sequence<T>[]
): Iterable<N> {
  for (const array of arrays) {
    for (const item of array) {
      yield func(item)
    }
  }
}
